// Shared real estate booking rules used by the /book flow. Package details live in lib/realEstatePackages.

export const TIME_WINDOWS = [
  { value: 'morning', label: 'Morning (8am–12pm)' },
  { value: 'afternoon', label: 'Afternoon (12pm–5pm)' },
  { value: 'flexible', label: 'Flexible' },
];

export const OCCUPANCY_OPTIONS = [
  { value: 'vacant', label: 'Vacant' },
  { value: 'owner_occupied', label: 'Owner Occupied' },
  { value: 'tenant_occupied', label: 'Tenant Occupied' },
];

// Exactly 2,000 sq ft is First Impressions; over 3,000 sq ft books Creator Spotlight only.
export const sizePackageFor = (sqft) => (sqft < 2000 ? 'signature' : sqft <= 3000 ? 'first_impressions' : null);

export const finalPackageFor = (formData) => {
  const sqft = parseInt(formData.squareFootage, 10) || 0;
  const size = sizePackageFor(sqft);
  return formData.useCreatorSpotlight || !size ? 'creator_spotlight' : size;
};

export const EMPTY_HOME_FORM = {
  street: '', unit: '', city: '', state: 'AZ', zipCode: '', squareFootage: '', useCreatorSpotlight: false,
  preferredDate1: '', preferredTime1: '', preferredDate2: '', preferredTime2: '',
  occupancy: '', lockboxCode: '', accessNotes: '', comments: '',
};

export const buildOrderPayload = (formData) => ({
  property_address: {
    street: formData.street.trim(),
    unit: formData.unit.trim() || null,
    city: formData.city.trim(),
    state: formData.state.trim(),
    zip_code: formData.zipCode.trim(),
  },
  square_footage: parseInt(formData.squareFootage, 10) || 0,
  package: finalPackageFor(formData),
  add_ons: [],
  preferred_date_1: { date: formData.preferredDate1, time_window: formData.preferredTime1 },
  preferred_date_2: formData.preferredDate2 && formData.preferredTime2
    ? { date: formData.preferredDate2, time_window: formData.preferredTime2 } : null,
  occupancy: formData.occupancy,
  lockbox_code: formData.lockboxCode.trim() || null,
  access_notes: formData.accessNotes.trim() || null,
  comments: formData.comments.trim() || null,
});
